var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBan = function SvgBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BA4D57",
    d: "M19.357 21.478 2.519 4.64a12 12 0 0 1 2.12-2.121l16.84 16.838a12 12 0 0 1-2.122 2.121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BA4D57",
    fillRule: "evenodd",
    d: "M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0m9-12C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0",
    clipRule: "evenodd"
  })));
};
export default SvgBan;